import { c as _c } from "react/compiler-runtime";
import type { SortingState } from '@tanstack/react-table';
import { useMemo } from 'react';
import { COLUMN_ID_TO_ORDER_BY, DEFAULT_ORDER_BY } from '../config/config';
export const useVaultsTableSorting = sorting => {
  const $ = _c(7);
  let t0;
  bb0: {
    const sortingItem = sorting[0];
    if (!sortingItem) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          orderBy: DEFAULT_ORDER_BY,
          desc: true
        };
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    const mappedOrderBy = COLUMN_ID_TO_ORDER_BY[sortingItem.id];
    const t1 = mappedOrderBy ?? DEFAULT_ORDER_BY;
    let t2;
    if ($[1] !== sortingItem.desc || $[2] !== t1) {
      t2 = {
        orderBy: t1,
        desc: sortingItem.desc
      };
      $[1] = sortingItem.desc;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t0 = t2;
  }
  const {
    orderBy,
    desc
  } = t0;
  let t1;
  if ($[4] !== desc || $[5] !== orderBy) {
    t1 = {
      orderBy,
      desc
    };
    $[4] = desc;
    $[5] = orderBy;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};